module.exports = __webpack_public_path__ + "img/UploadFileIcon.2e61631b.svg";